import React, {Suspense} from 'react';

import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Link } from "react-router-dom";
import Header from './components/Header';
import Footer from './components/Footer';
import Router from '../Router';


export default function Layout(props) {
  const {children} = props;

  return (
    <>
    <Box width="100%" sx={{display:'flex', minHeight:'100%', flexDirection:'column', alignItems:'stretch'}}>
    <Box width="100%" sx={{flexShrink:0}}>
      <Header/>
    </Box>
    <Suspense fallback={<></>}>
    {/* <>{children}</> */}
    <Box width="100%" sx={{flexShrink:0,flexGrow:1}}>
      <Router/>
    </Box>
    </Suspense>
     {/* <Header/> */}
    <Box width="100%" sx={{flexShrink:0}}>
      <Footer/>
    </Box>
    </Box>
    </>
  );
}

Layout.defaultProps ={
  children: <></>
}